import { BodyText } from '@policygenius/mortar';
import { FormRenderProps } from 'react-final-form';

import SelectField from 'components/formInputs/SelectField';
import FormWrapper from 'components/FormWrapper';
import InputRecommendationCard from 'components/InputRecommendationCard';
import { InitialValues } from 'forms/types';
import { RECOMMENDATION_HEADING } from 'pages/WaitingPeriod/constants';

import {
  BENEFIT_PERIOD_LABEL,
  BENEFIT_PERIOD_OPTIONS,
  RECOMMENDATION_TEXT_1,
  RECOMMENDATION_TEXT_2,
} from './constants';
import { BenefitPeriodFormValues } from './types';

const BenefitPeriodForm: React.FC<
  FormRenderProps<BenefitPeriodFormValues, InitialValues<BenefitPeriodFormValues>>
> = ({ handleSubmit, invalid, submitting }) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <InputRecommendationCard
      leftPaneBody={
        <SelectField
          label={BENEFIT_PERIOD_LABEL}
          name="benefitPeriod"
          options={BENEFIT_PERIOD_OPTIONS}
        />
      }
      rightPaneBody={
        <>
          <BodyText as="strong" weight="bold">
            {RECOMMENDATION_TEXT_1}
          </BodyText>{' '}
          <BodyText as="span">{RECOMMENDATION_TEXT_2}</BodyText>
        </>
      }
      rightPaneTitle={RECOMMENDATION_HEADING}
    />
  </FormWrapper>
);

export default BenefitPeriodForm;
